// import Blog Img
import Blog1 from "../../assets/img/blog/blog-1.png"
import Blog2 from "../../assets/img/blog/blog-2.png"
import Blog3 from "../../assets/img/blog/blog-3.png"

// Import Icon
import IconUser from "../../assets/img/icon/user.png"
import IconDate from "../../assets/img/icon/cal.png"




export const NewsAreaData = [
 
  {
    img:Blog1,
    heading:`Badminton ladder & new hall times posted`,
    category:"#Badminton",
    para:`Our main sport gets fresh court-time slots and an updated ladder—juniors and adults can enter before the deadline in the email blast.`,
    IconUser:IconUser,
    IconDate:IconDate
  },

  {
    img:Blog2,
    heading:`Integration evening: “Talking to your child’s school”`,
    category:"#Integration",
    para:`Volunteers share how Swedish parent-teacher contact works and how to prepare for development talks—with Urdu whisper translation where possible.`,
    IconUser:IconUser,
    IconDate:IconDate
  },
  {
    img:Blog3,
    heading:`Swim block opens — summer readiness`,
    category:"#Swimming",
    para:`Seasonal pool sessions for children and teens return; lifeguard rules and group lists will be shared to registered families.`,
    IconUser:IconUser,
    IconDate:IconDate
  },
  {
    img:Blog1,
    heading:`Football friendly day — sign-up for autumn`,
    category:"#Football",
    para:`One-off pitch day to form teams for the cooler months; badminton remains our core indoor programme year-round.`,
    IconUser:IconUser,
    IconDate:IconDate
  },

  {
    img:Blog2,
    heading:`Eid social & youth badminton challenge`,
    category:"#Culture",
    para:`Celebrate together, then a fun doubles challenge for teenagers with small prizes—everyone welcome to watch.`,
    IconUser:IconUser,
    IconDate:IconDate
  },
  {
    img:Blog3,
    heading:`Welcome new integration & sports volunteers`,
    category:"#PCF",
    para:`PCF thanks outgoing coordinators and welcomes volunteers steering badminton, seasonal sports, and integration evenings.`,
    IconUser:IconUser,
    IconDate:IconDate
  },
]
